import { useI18n } from "../i18n";
export const SessionLog = ({ entries }) => {
  const { t } = useI18n();
  return (
  <div className="max-h-72 overflow-y-auto font-mono text-sm" data-testid="ghost-log-list">
    {entries.length === 0 && <p className="text-subtle py-6">{t("noLog")}</p>}
    {[...entries].reverse().map((e, i) => (
      <div key={e.id || `${e.time}-${i}`} className="flex gap-4 py-2 border-b border-line log-row" data-testid={`log-entry-${entries.length - 1 - i}`}>
        <span className="text-subtle w-20 shrink-0">{e.time}</span>
        {e.type === "q" ? (
          <span className="text-violet">{t("question")} › {e.text}</span>
        ) : (
          <>
            <span className="text-cyan w-20 shrink-0">{e.freq.toFixed(1)}</span>
            <span className="text-amber font-bold tracking-wider">{e.word}</span>
          </>
        )}
      </div>
    ))}
  </div>
  );
};
